import React, { Component } from 'react'
import styled from 'styled-components'
import LiquidLoader from './LiquidLoader'

export default class Loader extends Component {
  render () {
    const { loading, children } = this.props

    return (
      <LoaderContainer $loading={loading}>
        {loading
          ? (
            <LoaderContent>
              <LiquidLoader size={120} />
              <LoaderText>Caricamento in corso...</LoaderText>
            </LoaderContent>
            )
          : (
              children
            )}
      </LoaderContainer>
    )
  }
}

const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.$loading ? 'center' : 'flex-start'};
  align-items: ${props => props.$loading ? 'center' : 'stretch'};
`

const LoaderContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
`

const LoaderText = styled.i`
  font-size: 0.875rem;
  color: ${props => props.theme.colors?.text?.tertiary || '#666666'};
  font-style: italic;
`
